// extracted by mini-css-extract-plugin
module.exports =  {"control":"lP6iyUf"};